import { Injectable, Injector } from '@angular/core';
import { BaseResourceService, FavorecidoSocio } from 'eddydata-lib';

@Injectable({
  providedIn: 'root'
})
export class FavorecidoSocioService extends BaseResourceService<FavorecidoSocio> {

  constructor(
    protected injector: Injector
  ) {
    super(`favorecido-socios`, injector);
  }

}
